import axios from "axios";
const jsonConfig = require("../../Config.json");

const getUsersById = async (Id) => {
  let allResponse = {};
  try {
    const getallresponse = await axios.get(
      jsonConfig.apiUrl + "users/" + Id,
      {
        headers: {
          "x-functions-key": jsonConfig.key,
        },
      }
    );

    allResponse = getallresponse;
    return Promise.resolve(allResponse);
  }
  catch (error) {
    console.log("Error user id", error);
    return Promise.reject(error);
  }
}

export default getUsersById;